import { getStationLineDirectionArrow } from '@openlayers/ol-utils';
import { DrawInteractionTool } from '@openlayers/tools/tool-base';
import { MapWrapper } from '@openlayers/MapWrapper';

import { LineString } from 'ol/geom';
import { transform as olTransform } from 'ol/proj';
import OlOverlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import { Coordinate } from 'ol/coordinate';
import { Type as OlGeometryType } from 'ol/geom/Geometry';
import * as olStyle from 'ol/style';


export class FreeCrossSectionTool extends DrawInteractionTool {
    geometryType: OlGeometryType = 'LineString';

    style = new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: 'rgba(0, 0, 0, 1)',
            width: 2,
        }),
    });

    constructor(
        mapWrapper: MapWrapper,
        private onOpen: (latLon1: [number, number], latLon2: [number, number]) => void
    ) {
        super(mapWrapper);
    }

    onDrawStart = (e) => { // OlDrawEvent
        this.clear();
        const currFeature: Feature = e.feature;
        const sourceProj = this.mapWrapper.getProjection();

        let labelP2: OlOverlay = null;
        let lonLat2: Coordinate = null;
        let arrow: Feature = null;

        const labelP1: OlOverlay = this.createLabel(currFeature);
        const coord1: Coordinate = (currFeature.getGeometry() as LineString).getCoordinates()[0];
        const lonLat1: Coordinate = olTransform(coord1, sourceProj, 'EPSG:4326');

        labelP1.getElement().parentElement.style.pointerEvents = 'none';
        labelP1.getElement().innerHTML = lonLat1[1].toFixed(5) + ', ' + lonLat1[0].toFixed(5);
        labelP1.setPosition(coord1);
        labelP1.setOffset([0, -10]);
        this.mapWrapper.getInstance().addOverlay(labelP1);

        currFeature.setStyle(this.style);
        this.drawLayer.setStyle(this.style);
        this.mapWrapper.addLayer(this.drawLayer, 98, 'tool-draw');

        this.geometryListener = currFeature.getGeometry().on('change', e => {
            const geom = e.target;
            const coords = geom.getCoordinates();

            if (coords.length == 2) {
                if (!labelP2) {
                    labelP2 = this.createLabel(currFeature);
                    this.mapWrapper.getInstance().addOverlay(labelP2);
                }
                lonLat2 = olTransform(coords[1], sourceProj, 'EPSG:4326');
                labelP2.getElement().innerHTML = lonLat2[1].toFixed(5) + ', ' + lonLat2[0].toFixed(5);
                labelP2.setPosition(geom.getLastCoordinate());
                labelP2.setOffset([0, -10]);

                if (!arrow) {
                    arrow = new Feature();
                    arrow.setId('free_station_arrow');
                    this.drawLayer.getSource().addFeature(arrow);
                }
                const lineString = getStationLineDirectionArrow(coord1, coords[1]);

                lineString.push(coord1);
                arrow.setGeometry(new LineString(lineString));
            }

            if (coords.length > 2) {
                this.drawInteraction.finishDrawing();
                this.openFreeCrossSectionWindow(lonLat1, lonLat2);
                this.onDrawEnd();
            }
        });
    }

    openFreeCrossSectionWindow = (latLng1: Coordinate, latLng2: Coordinate) => {
        this.onOpen(
            [parseFloat(latLng1[1].toFixed(6)), parseFloat(latLng1[0].toFixed(6))],
            [parseFloat(latLng2[1].toFixed(6)), parseFloat(latLng2[0].toFixed(6))]
        );
    }

    deactivate = () => {
        super.deactivate();
        this.clear();
    }

    clear = () => {
        super.clear();
        this.drawLayer.getSource().clear();
    }
}

